import FormStore from "../../Configs/Stores/FormStore"
import AppStore from "../../Configs/Stores/AppStore"

const Blowfish = require("egoroof-blowfish")
const Buffer = require("buffer").Buffer

const BF_KEY = ["!t@a6@($%(", "DIGI1234", "Mt%sOmD17r-pqZN", "!i@*6@($%("]
const BF_MODE = Blowfish.MODE.EBC
const BF_PADDING = Blowfish.PADDING.PKCS5
const BF_TYPE = Blowfish.TYPE.STRING

const BF_OG = new Blowfish(BF_KEY[0], BF_MODE, BF_PADDING)
const BF_DG = new Blowfish(BF_KEY[1], BF_MODE, BF_PADDING)
const BF_DEP = new Blowfish(BF_KEY[2], BF_MODE, BF_PADDING)
const BF_GRPEMP = new Blowfish(BF_KEY[3], BF_MODE, BF_PADDING)

const BlowFishReact = (encrypt, key, data) => {
  let BF = key === "DIGI" ? BF_DG : key === "DEP" ? BF_DEP : key === "GRPEMP" ? BF_GRPEMP : BF_OG
  if (encrypt) {
    var encryptedData = BF.encode(key === "GRPEMP" ? data : JSON.stringify(data))
    encryptedData = Buffer.from(encryptedData).toString("base64")
    return encryptedData
  } else {
    var dataBuffered = Buffer.from(data, "base64")
    var decryptedData = BF.decode(dataBuffered, BF_TYPE)
    return decryptedData
  }
}

const numDifferentiation = (val, point, short = false, isRaw = false) => {
  if (isNaN(val) || !val) return 0

  // point += 1
  val = Math.round(val)

  if (isRaw) return addCommas(val)

  if (val >= 10000000) {
    val = (val / 10000000).toFixed(point)
    // val = val.length > 4 ? val.slice(0, 4) : val
    val = parseFloat(val) + (short ? " Cr" : " Crore")
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(point)
    // val = val.length > 4 ? val.slice(0, 4) : val
    val = parseFloat(val) + (short ? " L" : " Lakh")
  } else {
    val = parseFloat(val).toFixed(0)
    val = (val + "").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
  }
  return val
}

var UserDataJSON = window.UserDataJSON
var clientId = window.clientId
var PrefillUserJson = window.PrefillUserJson

var fillLead_flag = window.fillLead_flag
var gamoogaEvent = window.gamoogaEvent
var Enc_UserData = window.Enc_UserData
var isDate = window.isDate
var Glb_UID = window.Glb_UID

async function CreateReactCookie() {
  var UserInput = window.UserInput
  var cookieTS = new Date().getTime()
  try {
    for (var key in UserInput) {
      if (UserInput[key] != undefined) {
        PrefillUserJson[key] = UserInput[key].toString()
      }
    }
    if (isDate(UserInput.dob)) {
      var d = new Date()
      d.setTime(d.getTime() + 91 * 24 * 60 * 60 * 1000)
      var expires = "expires=" + d.toUTCString()
      var UserDataJSON = (Enc_UserData = "")
      var birthdateorig = UserInput.dob.split("/")
      var currentyear = new Date().getFullYear()
      var date2 = new Date()
      var finaldob = new Date(birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear)
      var finaldob = new Date(birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear)
      var timeDiff = finaldob.getTime() - date2.getTime()
      var daysdiff = Math.ceil(timeDiff / (1000 * 24 * 3600))
      try {
        PrefillUserJson.GAid = document.cookie.split("GA_VisitorID=")[1].split(";")[0]
      } catch {
        PrefillUserJson.GAid = ""
      }
      PrefillUserJson.PageName = "Child Education Planner"
      PrefillUserJson.UID = Glb_UID
      PrefillUserJson.timeStamp = cookieTS
      var UserDataJSON = await BlowFishReact(true, "", PrefillUserJson)
      // var UserDataJSON2 = await BlowFishReact(false, "", UserDataJSON)
      // console.log("User data decrypted", UserDataJSON2)
      document.cookie = "CEPCookie=" + UserDataJSON + ";" + expires + ";path=/"
      console.log("document.cookie", document.cookie)
      if (date2.getMonth() == 10 || date2.getMonth() == 11) {
        if (finaldob.getMonth() >= date2.getMonth()) {
        } else {
          currentyear = currentyear + 1
          finaldob = new Date(birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear)
        }
      }
      if (daysdiff > 0 && daysdiff <= 60) {
        localStorage.setItem("BirthdayUsecase", "true")
      } else {
        localStorage.setItem("BirthdayUsecase", "false")
      }

      if (UserInput.TRAI_FLAG === "YES") {
        window.GamoogaDataFlow()
      }
    }
  } catch (e) {
    console.log("Error: CreateCookie Function - " + e)
  }

  var UserDataJSON1 = "CEPproductId=NONE&dob=" + UserInput.dob + "&timestamp=" + cookieTS + "&ends=" + this
  UserDataJSON1 = await BlowFishReact(true, "", UserDataJSON1)
  // console.info("UserDataJSON1 :", UserDataJSON1)
  document.cookie = "encryptedCookie=" + UserDataJSON1 + ";" + expires + ";path=/"

  if (typeof setStorageBoi === "function") {
    setStorageBoi(UserInput, "productInfoCEP")
  }

  try {
    if (UserInput.TRAI_FLAG == "YES") {
      window.GamoogaDataFlow()
    }
  } catch (e) {
    console.log("Error: CreateCookie Gamooga - " + e)
  }
}

// functions to add and remove commas

const addCommas = (nStr) => {
  return nStr.toString().replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")
}

const removeCommas = (numWidCommas) => {
  return numWidCommas.replace(/[,]/g, "")
}

const downloadFile = (url, fileName) => {
  var element = document.createElement("a")
  element.setAttribute("href", url)
  element.setAttribute("target", "_blank")
  element.setAttribute("download", fileName)
  element.setAttribute("type", "application/pdf")
  element.style.display = "none"
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

const numConvert = (n) => {
  let ord = ["st", "nd", "rd"]
  let exceptions = [11, 12, 13]
  let nth = ord[(n % 10) - 1] === undefined || exceptions.includes(n % 100) ? "th" : ord[(n % 10) - 1]
  return n + nth
}

const scrollToClass = (target, position = "center") => {
  var element = document.getElementsByClassName(target)[0]
  element.scrollIntoView({ behavior: "smooth", block: position })
}

const scrollToTargetHorizon = (target) => {
  console.info("ScrollToTarget :", target)
  target.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })
}


const scrollToClassHorizon = (target, ref) => {
  var element = document.querySelector(`.${target}`)
  console.info("ScrollToClass :", element)
  element.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })
}

const scrollToId = (target) => {
  var element = document.getElementById(target)
  element.scrollIntoView({ behavior: "smooth", block: "center" })
}

const scrollToRef = (ref) => {
  ref.current.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "start"
  })
}

const getCookieBoi = async (cname) => {
  try {
    var name = cname + "="
    var data = document.cookie.split("encryptedCookie=")
    var UserDataJSON = await BlowFishReact(false, "", data[1])
    UserDataJSON = UserDataJSON.replace('"', "")
    // console.log("UserDataJSON", UserDataJSON)
    UserDataJSON = UserDataJSON.split("&ends")[0]
    var ca = UserDataJSON.split("&")
    // console.log("UserDataJSON", UserDataJSON, ca)
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === " ") {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  } catch (err) {
    // console.info("CA Debug 3 No Enc Cookie", err)
  }
}

const getStorageBoi = async (key, count = 0) => {
  count = count + 1
  if (count > 5) {
    return false
  }
  try {
    var value = await JSON.parse(window.$.jCryptionDIGI.decrypt(localStorage.getItem(key), "encrypt"))
    console.info("getStorageBoi Value :", window.UserInput.dob, value.dob)
    if (window.UserInput.dob === value.dob) {
      console.log("value matched")
      window.localDobFlag = true
      return value
    }
  } catch (e) {
    console.log("getStorageBoi: Error reading key [" + key + "] from localStorage: " + JSON.stringify(e))
    return new Promise((res) => setTimeout(() => res(getStorageBoi(key, count)), 1000))
  }
}

const getReactStorageBoi = async (key) => {
  // Prodigy Funtion
  try {
    var tempStorage = localStorage.getItem(key + "_R")
    var SyncDOB = await BlowFishReact(false, "DEP", tempStorage)
    return JSON.parse(SyncDOB)
  } catch {
    return false
  }
}

const setStorageBoi = async (data, key, count = 0) => {
  console.info("Set Storage :", data)
  count = count + 1
  if (count > 5) {
    return false
  }
  if (count === 1) {
    var SyncDOB = await BlowFishReact(true, "DEP", data)
    localStorage.setItem(key + "_R", SyncDOB)
  }
  try {
    var dataStr = JSON.stringify(data)
    var encryptedData = window.$.jCryptionDIGI.encrypt(dataStr, "encrypt")
    localStorage.setItem(key, encryptedData)
    console.info("setStorageBoi Passed :", data, key, count)
  } catch (e) {
    console.log("setStorageBoi: Error setting key [" + key + "] in localStorage: " + JSON.stringify(e))
    return new Promise((res) => setTimeout(() => res(setStorageBoi(data, key, count)), 1000))
  }
  return true
}

const isJson = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const capitalize = (str) => {
  try {
    return str[0].toUpperCase() + str.slice(1)
  } catch {
    return str
  }
}

const scrollPatch = (type) => {
  setTimeout(() => {
    try {
      var contentWrapper = document.getElementsByTagName("body")[0]
      if (contentWrapper.hasAttribute("style")) {
        contentWrapper.style.overflow = type
      }
    } catch { }
  }, 1000)
}

const GrabToHScroll = (target) => {
  const slider = document.querySelector(`.${target}`)
  console.info("GrabToHScroll :", slider)
  let mouseDown = false
  let startX, scrollLeft
  let startDragging = function (e) {
    mouseDown = true
    startX = e.pageX - slider.offsetLeft
    scrollLeft = slider.scrollLeft
  }
  let stopDragging = function (event) {
    mouseDown = false
    if (slider.classList.contains("Grabbing")) slider.classList.remove("Grabbing")
    slider.classList.add("Grab")
  }
  slider.addEventListener("mousemove", (e) => {
    e.preventDefault()
    if (!mouseDown) {
      return
    }
    if (slider.classList.contains("Grab")) slider.classList.remove("Grab")
    slider.classList.add("Grabbing")
    const x = e.pageX - slider.offsetLeft
    const scroll = x - startX
    slider.scrollLeft = scrollLeft - scroll
  })
  slider.addEventListener("mousedown", startDragging, false)
  slider.addEventListener("mouseup", stopDragging, false)
  slider.addEventListener("mouseleave", stopDragging, false)
}

const UserInput = (key, subKey, value) => {
  if (subKey !== "") {
    window.UserInput[key][subKey] = value
  } else {
    window.UserInput[key] = value
  }
}

const numWords = (input) => {
  const a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen "
  ]
  const b = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"]
  const regex = /^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/
  const getLT20 = (n) => a[Number(n)]
  const getGT20 = (n) => b[n[0]] + " " + a[n[1]]

  const num = Number(input)
  if (input <= 999999999) {
    if (isNaN(num)) return ""
    if (num === 0) return "zero"
    const numStr = num.toString()
    if (numStr.length > 9) {
      throw new Error("overflow") // Does not support converting more than 9 digits yet
    }
    const [, n1, n2, n3, n4, n5] = ("000000000" + numStr).substr(-9).match(regex) // left pad zeros
    let str = ""
    str += n1 != 0 ? (getLT20(n1) || getGT20(n1)) + "crore " : ""
    str += n2 != 0 ? (getLT20(n2) || getGT20(n2)) + "lakh " : ""
    str += n3 != 0 ? (getLT20(n3) || getGT20(n3)) + "thousand " : ""
    str += n4 != 0 ? getLT20(n4) + "hundred " : ""
    str += n5 != 0 && str != "" ? "and " : ""
    str += n5 != 0 ? getLT20(n5) || getGT20(n5) : ""
    let res = str.trim()
    return res
  } else {
    return ""
  }
}

const numToSup = (number) => {
  if (number === 1) {
    return "1<sup>st</sup>"
  } else if (number === 2) {
    return "2<sup>nd</sup>"
  } else if (number === 3) {
    return "3<sup>rd</sup>"
  } else {
    return `${number}<sup>th</sup>`
  }
}

const modeAlias = (value) => {
  if (value === "Monthly") {
    return "p.m."
  } else if (value === "Half-Yearly") {
    return "half-yearly"
  } else if (value === "Yearly") {
    return "p.a."
  } else {
    return ""
  }
}

const CollectTaxSavings = (InvestValue, PayFor, TotalReturns, ModeFactor) => {
  InvestValue = InvestValue * ModeFactor

  let AValue = InvestValue
  let AValuePayFor = InvestValue * PayFor

  let BValue = 0.312 * AValue
  BValue = BValue > 46800 ? 46800 : BValue

  let CValue = BValue * PayFor
  let DValue = 0.312 * (TotalReturns - AValuePayFor)

  return {
    InvestValue,
    AValue,
    AValuePayFor,
    BValue,
    CValue,
    DValue
  }
}

const CollectBenefits = (PlanType, PayFor, withValue, Regular, Additional, modeFactor, freqFactor, isEmployee) => {
  var percentage = 0
  var factor = 1
  if (PlanType === "Income") {
    percentage = isEmployee ? 6.5 : 2.5
    factor = isEmployee ? 1.065 : 1.025
  } else if (PlanType === "Early-Income") {
    percentage = isEmployee ? 9 : 3.5
    factor = isEmployee ? 1.09 : 1.035
  } else if (PlanType === "Lump-Sum" && PayFor === 1) {
    percentage = isEmployee ? 2 : 1
    factor = isEmployee ? 1.02 : 1.01
  } else if (PlanType === "Lump-Sum" && PayFor !== 1) {
    percentage = isEmployee ? 6.5 : 2.5
    factor = isEmployee ? 1.065 : 1.025
  }

  var withoutValue = 0

  if (PlanType === "Income") {
    withoutValue = withValue / factor
  } else if (PlanType === "Early-Income") {
    withValue = Additional * modeFactor * PayFor + Regular * PayFor * freqFactor
    withoutValue = Additional * modeFactor * PayFor + (Math.round(Regular) / factor) * PayFor * freqFactor
  } else if (PlanType === "Lump-Sum" && PayFor === 1) {
    withoutValue = withValue / factor
  } else if (PlanType === "Lump-Sum" && PayFor !== 1) {
    withoutValue = withValue / factor
  }

  const difference = withValue - withoutValue
  return {
    percentage,
    withValue,
    withoutValue,
    difference,
    factor
  }
}

//Masking Common Function
const mask = (value) => {
  const data = value.split("")
  var len = data.length
  var newarr = []
  for (var i = 0; i <= len - 1; i++) {
    if (i == 0 || i == 1 || i == len - 1) {
      newarr[i] = data[i]
    } else {
      newarr[i] = "X"
    }
  }
  const response = newarr.toString().replace(/,/g, "")
  return response
}

const maskData = (value) => {
  const dob = value.split("/")
  const data = dob[0] + "/XX" + "/XXX" + dob[2].substring(dob[2].length - 1, dob[2].length)
  return data
}

const maskMobile = (value) => {
  const mob = value.toString().split("")
  const maskedmob = mob[0] + mob[1] + "XXXXXXX" + mob[9]
  return maskedmob
}

const maskEmail = (value) => {
  const mail = value.split("@")
  const provider = mail[1].split(".")
  const name = mask(mail[0])
  const mailprovider0 = mask(provider[0])
  const mailprovider1 = mask(provider[1])
  console.log(name, "@", provider)
  const maskedMail = name + "@" + mailprovider0 + "." + mailprovider1
  return maskedMail.toLowerCase()
}

const HideLandingLoader = () => {
  document.querySelector(".Spinner_Background").style.display = "none"
  var spinner = document.querySelector("body").classList
  if (spinner.contains("Spinner_Default")) spinner.remove("Spinner_Default")
  document.querySelector("html").style.overflow = ""
}
window.UserSession = {
  SessionToken: "",
  JwtToken: "",
}
async function generateJWTToken(iSUat) {
  try {
    const headers = new Headers()
    const authValue = iSUat ? "RFFGdVBCV3BpdXRjQmlmb3R2aXl5bVFIaVM3RXAyM1Q6bURYa05iOXd3ZmZQVGNGTQ==" : "bkdLUHNpWklCdU9LbWhvODFzTE1BY2Vva3EzbUJRVks6enBaUnZSd3h5ekR4NUc4aw=="
    headers.append("Authorization", `Basic ${authValue}`)
    var payloadOption = {
      method: "POST",
      credentials: "include",
      headers: headers,
    }
    const jwtReq = iSUat ? await fetch("https://api-dex.iciciprulife.com/v1/oauth/jwt", payloadOption) : await fetch("https://api.iciciprulife.com/v1/oauth/jwt", payloadOption)
    const jwtRes = await jwtReq.json()
    // console.log(jwtRes)
    const token = jwtRes.token
    window.UserSession["JwtToken"] = token
    return token
  } catch (e) {
    // console.log("Error Occured while creating JWT Token: ", e)
    return e
  }
}
async function generateSessionToken(tokenString, iSUat) {
  try {
    var headers = new Headers()
    headers.append("Authorization", `Bearer ${tokenString}`)
    headers.append("Content-Type", "application/json")
    var rawBody = JSON.stringify({ appCode: "BOLTECH" })
    const payloadOption = {
      method: "POST",
      headers: headers,
      body: rawBody,
      credentials: "include",
    }
    const sessionRes = iSUat ? await fetch("https://api-dex.iciciprulife.com/bol/middleware/generate/token", payloadOption) : await fetch("https://api.iciciprulife.com/bol/middleware/generate/token", payloadOption)
    // const sessionRes = await fetch("https://api.iciciprulife.com/bol/middleware/generate/token", payloadOption)
    if (sessionRes.status === 200) {
      var sessionData = await sessionRes.json()
      const { status, token } = sessionData
      // console.log(status)
      window.UserSession["SessionToken"] = token
      return [token]
    } else {
      // console.log("Invalid response from server")
      return [null]
    }
  } catch (e) {
    console.log("Error Occurred on Generating Session Token: ", e)
    return 0
  }
}
const InjectCustomAppForm = () => {
  var randomTS = new Date().getTime()
  var s = document.createElement("script")
  s.src = process.env.REACT_APP_APPFORM + randomTS // Prod
  document.body.appendChild(s)
}

const suitablityUserInput = (key, subKey, value) => {
  if (subKey !== "") {
    window.suitablity_UserInput[key][subKey] = value
  } else {
    window.suitablity_UserInput[key] = value
  }
}

const GetPersonaType = () => {
  const Params = new URL(window.location.href).searchParams
  const PersonaURL = Params.get("persona")
  if (PersonaURL === "Income" || PersonaURL === "Early_Income" || PersonaURL === "Lump_Sum" || PersonaURL === "Lump_Sum_FD" || PersonaURL === "Child") {
    return PersonaURL
  } else {
    return "Income"
  }
}

const ExistingCustomer = (count = 0) => {
  count = count + 1
  if (count <= 20) {
    if (typeof window.$ !== "undefined") {
      var isCustomerEmpty = document.getElementsByTagName("existingcusthtml").length === 0
      if (isCustomerEmpty) {
        setTimeout(() => {
          if (typeof window.existingCustToaster === "function") {
            window.existingCustToaster()
          }
        }, 250)
        setTimeout(ExistingCustToaster, 1000)
      }
    } else {
      setTimeout(ExistingCustomer, 1000, count)
    }
  } else {
    console.warn("EC Timeout")
  }
}

const ExistingCustToaster = () => {
  try {
    document.getElementsByClassName("ex-cust-toaster-container")[0].style.zIndex = 1305
    if (typeof window.loadCustomerReact === "function") {
      window.loadCustomerReact()
    }
  } catch {
    console.warn("EC Invalid")
  }
}
const AppFormFunctions = (flag) => {
  var isResume = flag === 1
  console.warn("Looping Ropes...")
  // console.warn("areDependencyLoaded :", isResume, window.UserDataJSON, window.PopulateAppForm, window.Messageorder_cust, window.configFieldsInfo)
  if (
    typeof window.UserDataJSON === "object" &&
    typeof window.PopulateAppForm === "function" &&
    typeof window.Messageorder_cust === "object" &&
    typeof window.configFieldsInfo === "object" &&
    typeof window.Service_OCR === "function"
  ) {
    return true
  } else {
    return false
  }
}

const ToggleBootstrapStyle = (enable, count = 0) => {
  var allTags = document.querySelectorAll("link[href*='bootstrap.min.css']")
  console.warn("AllTags :", allTags, count)

  if (!enable) {
    if (allTags.length > 0) {
      allTags.forEach((e) => {
        e.setAttribute("disabled", "")
      })
    } else {
      count = count + 1
      if (count < 100) {
        setTimeout(ToggleBootstrapStyle, 100, enable, count)
      }
    }
  } else {
    allTags.forEach((e) => {
      e.removeAttribute("disabled")
    })
  }
}

const debounce = (Func, DELAY) => {
  clearTimeout(Func._delay)
  Func._delay = setTimeout(() => {
    Func()
  }, DELAY)
}

const GimmeMahChildAge = () => {
  if (Math.sign(FormStore.calc_childAge) === 0 && FormStore.calc_childMonths > 0) {
    return `${AppStore.isQDataMasked.childDOB ? "XX" : FormStore.calc_childMonths} Month${FormStore.calc_childMonths > 1 ? "s" : ""}`
  } else if (Math.sign(FormStore.calc_childMonths) === 0 && FormStore.calc_childDays > 0) {
    return `${AppStore.isQDataMasked.childDOB ? "XX" : FormStore.calc_childDays} Day${FormStore.calc_childDays > 1 ? "s" : ""}`
  } else if (Math.sign(FormStore.calc_childAge) === 1) {
    return `${AppStore.isQDataMasked.childDOB ? "XX" : FormStore.calc_childAge} Year${FormStore.calc_childAge > 1 ? "s" : ""}`
  } else {
    return ""
  }
}
const maskPinCode = (value) => {
  const pin = value.toString().split("")
  const maskedpin = pin[0] + pin[1] + "XXX" + pin[5]
  return maskedpin
}

export {
  BlowFishReact,
  UserInput,
  suitablityUserInput,
  numDifferentiation,
  removeCommas,
  addCommas,
  downloadFile,
  numConvert,
  scrollToClassHorizon,
  scrollToTargetHorizon,
  scrollToClass,
  scrollToId,
  scrollToRef,
  getCookieBoi,
  setStorageBoi,
  getStorageBoi,
  isJson,
  capitalize,
  scrollPatch,
  GrabToHScroll,
  CreateReactCookie,
  numWords,
  numToSup,
  modeAlias,
  getReactStorageBoi,
  HideLandingLoader,
  InjectCustomAppForm,
  maskData,
  maskEmail,
  maskMobile,
  GetPersonaType,
  CollectBenefits,
  CollectTaxSavings,
  ExistingCustToaster,
  AppFormFunctions,
  ExistingCustomer,
  ToggleBootstrapStyle,
  debounce,
  GimmeMahChildAge, generateJWTToken, maskPinCode
}
